/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_No_NotesInputs */

const en_case_detail_no_notes = /** @type {(inputs: Case_Detail_No_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No notes recorded.`)
};

const pt_br2_case_detail_no_notes = /** @type {(inputs: Case_Detail_No_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma anotação registrada.`)
};

/**
* | output |
* | --- |
* | "No notes recorded." |
*
* @param {Case_Detail_No_NotesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_no_notes = /** @type {((inputs?: Case_Detail_No_NotesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_No_NotesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_no_notes(inputs)
	return pt_br2_case_detail_no_notes(inputs)
});